import React from 'react';
import loadable from '@loadable/component';
import GlobalNav from '@99designs/frontend-components/apps/global-nav/components/GlobalNav/GlobalNav';
import SiteFooter from '@99designs/frontend-components/apps/global-nav/components/SiteFooter/SiteFooter';
import SiteHeader from '@99designs/frontend-components/apps/global-nav/components/SiteHeader/SiteHeader';
import { Role } from '@99designs/frontend-components/apps/global-nav/consts';
import { Site } from '@99designs/frontend-components/apps/global-nav/lib/Site';
import { Loading } from '@99designs/spa-common';
import { useViewer } from '@99designs/viewer';
import { getNavigationRole } from './getNavigationRole';

type FooterStyle = 'focused' | 'reduced' | 'full';

const Drawers = loadable(
    () =>
        import(
            '@99designs/frontend-components/apps/global-nav/components/GlobalNavDrawers/GlobalNavDrawers'
        )
);

interface LayoutProps {
    role?: Role;
    site: Site;
    children: React.ReactNode;
    footerStyle?: FooterStyle;
}

function Layout({ children, role, site, footerStyle = 'focused' }: LayoutProps) {
    const viewer = useViewer();
    const navRole = !role ? getNavigationRole(viewer) : role;

    return (
        <GlobalNav>
            {({ toggleDrawer, drawerState }) => (
                <>
                    <SiteHeader
                        role={navRole}
                        site={site}
                        variations={['gradient']}
                        onLeftDrawerTriggerClick={toggleDrawer('left', true)}
                        onRightDrawerTriggerClick={toggleDrawer('right', true)}
                    />
                    {children}
                    <Drawers
                        toggleDrawer={toggleDrawer}
                        role={navRole}
                        site={site}
                        drawerState={drawerState}
                        fallback={<Loading />}
                    />
                    <SiteFooter
                        site={site}
                        isFocused={footerStyle === 'focused'}
                        isReduced={footerStyle === 'reduced'}
                        // full footer doesn't require anything to be set, it's the default
                    />
                </>
            )}
        </GlobalNav>
    );
}

export default Layout;
